import API from "@/services/api";
import { FetchLanguageResponse } from "../types/language";

export enum Endpoints {
  fetchTranslations = "/translations",
}

const fetchTranslations = (lang: string) => {
  return new Promise<FetchLanguageResponse>(async (resolve, reject) => {
    API.get<FetchLanguageResponse>({
      endpoint: `${Endpoints.fetchTranslations}/${lang}`,
      versions: [1]
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}


export default {
  fetchTranslations
};